<ui-page-header>Mein Konto</ui-page-header>

@if (authorized()) {
  @if (isAtAccountRoot()) {
    <ui-account-navigation
      [currentUrl]="currentPath() || ''"
      [nav]="navigation()"
      class="section-nav"
    ></ui-account-navigation>
  } @else {
    <div class="wrapper-content">
      <div class="section-data">
        @if (title(); as title) {
          <h1 class="h5">{{ title }}</h1>
        }
        @if (showCustomerNavigation()) {
          <ui-customer-navigation
            [ngClass]="currentPath()"
          ></ui-customer-navigation>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  }
} @else {
  User is not authorized
}
